import { Graphics, Container, Text, Point, ObservablePoint, Texture, extras } from 'pixi.js'
import { grid } from './index'

export default class RoomLabel extends Graphics {

  constructor(room) {
    super()

    // 対象の部屋
    this.room = room

    // ラベル
    this.label = new Text('', {align: 'center', fill: 0x333333, fontSize: 12})
    this.label.anchor.set(0.5, 0.5)
    this.addChild(this.label)

    // this.room.on('focus', () => this.focus())
    // this.room.on('blur', () => this.blur())

    this.room.on('updatedimension', () => this.updateDimension())
    this.room.on('updatecoordinate', () => this.updateCoordinate())

    this.updateDimension()
    this.updateCoordinate()

    return this
  }

  updateDimension() {
    let tatami = _.floor((this.room.dimension.x * this.room.dimension.y) / 2, 2)
    let square = _.floor(tatami * grid.shaku3 * grid.shaku3 * 2 , 2)
    this.label.text = `${this.room.config.label}\n${tatami}畳(${square}㎡)`
    this.label.position.set(this.room.calcWidth / 2 + 0.5, this.room.calcHeight / 2 + 0.5)
  }

  updateCoordinate() {
    this.position.set(this.room.position.x, this.room.position.y)
  }

  focus() {
  }

  blur() {
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/RoomLabel.js